module.exports = __webpack_public_path__ + "17aefd9944ef4948f6c62ed2bb1d314a.png";